"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSVField = void 0;
const papaparse_1 = __importDefault(require("papaparse"));
const Template_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/metadata/Template"));
const parseTypes_1 = require("@becrop/components/Toolkit/Heatmap2/models/metadata/parseTypes");
const randomkey_1 = __importDefault(require("@common/tsutils/randomkey"));
function PaPaParsePromise(file) {
    return new Promise(function (complete, error) {
        papaparse_1.default.parse(file, {
            // Config
            header: true,
            // Promise callbacks
            complete,
            error
        });
    });
}
class CSVField {
    constructor(name, data) {
        this.detected_type = null;
        this.type = null;
        this.selected = true;
        this.valid = false;
        this.rows_with_issues = 0;
        this.id = (0, randomkey_1.default)('csvfield');
        this.name = name;
        this.data = data;
    }
    validate() {
        this.valid = true;
        this.rows_with_issues = 0;
        if (!this.type) {
            this.valid = false;
            return;
        }
        for (const d of this.data) {
            try {
                (0, parseTypes_1.parseType)(this.type, d);
            }
            catch (e) {
                this.rows_with_issues++;
                this.valid = false;
            }
        }
    }
    parseData() {
        if (!this.type) {
            throw "No type selected";
        }
        const type = this.type;
        return this.data.map(d => (0, parseTypes_1.parseType)(type, d));
    }
}
exports.CSVField = CSVField;
class CSVMetadata {
    constructor() {
        this.filename = '';
        this.fields = [];
        this.data = [];
        this.codes = [];
    }
    async parse(file) {
        this.filename = file.name;
        const csv = await PaPaParsePromise(file);
        this.data = [];
        if (!csv.meta.fields || csv.meta.fields.length < 1) {
            throw "Error processing CSV";
        }
        const code_field = csv.meta.fields[0];
        //
        // Filter the rows with code
        //
        csv.data.forEach(row => {
            const code = row[code_field];
            if (!code)
                return;
            this.codes.push(code);
            this.data.push(row);
        });
        //
        // Get used fields
        //
        const fields_names = [];
        csv.meta.fields.forEach((field, i) => {
            // The code is in column 0
            if (i === 0)
                return;
            // Column has been marked as ignore
            if (field.includes(Template_1.default.IGNORE))
                return;
            // All items are null, ignore
            if (this.data.map(row => row[field]).every(val => !val))
                return;
            // This is a field with new data
            fields_names.push(field);
        });
        //
        // Create the fields
        //
        this.fields = fields_names.map(name => {
            const data = this.data.map(row => row[name]);
            return new CSVField(name, data);
        });
    }
    /**
     * Check if this csv has some missing types for the selected fields
     */
    hasMissingTypes() {
        const selectedFields = this.fields.filter(f => f.selected);
        if (selectedFields.length === 0)
            return true;
        return selectedFields.some(f => f.type === null);
    }
    getFieldsWithIssues() {
        return this.fields.filter(f => f.selected && !f.valid);
    }
    getFields() {
        return this.fields.filter(f => f.selected && f.valid && f.type !== null);
    }
    validate() {
        if (this.hasMissingTypes())
            return false;
        this.fields.forEach(f => f.validate());
        return this.getFieldsWithIssues().length === 0;
    }
}
exports.default = CSVMetadata;
